import React from 'react';
import utils from 'utils/utils';

module.exports = React.createClass({

  handleChange(ev){
    if (typeof this.props.onChange == 'function') {
      this.props.onChange(ev.target.value);
    }
  },

  render(){
    var list = utils.cloneArray(this.props.data || []);

    if (this.props.emptyItem) {
      list.unshift({id: -1, nome: ''});
    }

    var self = this;
    var items = list.map(function(item,index){
      return (
        <option value={item.id} key={index}>{item.nome}</option>
      );
    });

    return (
      <select {...this.props} onChange={this.handleChange} >
        {items}
      </select>
    );
  }


});


/** WEBPACK FOOTER **
 ** ./src/components/combo-box.js
 **/